
import NewsPage from '@/pages/noticias/index.vue'

export default {
  nuxtI18n: {
    paths: {
      br: '/noticias/:category',
      en: '/news/:category',
      es: '/noticias/:category'
    }
  },

  ...NewsPage
}
